import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sa-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.css']
})
export class TermsOfUseComponent implements OnInit {
  isFromPage: boolean;
  constructor() {
    this.isFromPage = true;
  }

  ngOnInit() {
  }

}
